import { RequestDataModel } from '@ktvs8/gocoo-engine-front-end';

export function findMProgramOrderByTicketKey(requestModel: RequestDataModel) {
  const ticketKey = requestModel.requestData['TicketKey'];
  return MProgramOrderTestData.find((x) => x.TicketKey === ticketKey);
}

/**
 * 発注書のテストデータ
 */
export const MProgramOrderTestData = [
  {
    TicketType: 'MProgramOrder',
    TicketKey: 'test#1111-1111-1111#000-0000-0000',
    ProgramCode: '1',
    Content: 'クリッター',
    Memo: '1500以下の攻撃力',
    ReceiptDateType: 'Onairdate',
    Weekday: 'NoLimit',
  },
  {
    TicketType: 'MProgramOrder',
    TicketKey: 'test#1111-1111-1111#000-0000-0001',
    ProgramCode: '2',
    Content: '黒き森のウィッチ',
    Memo: '1500以下の守備力',
    ReceiptDateType: 'Onairdate',
    Weekday: 'NoLimit',
  },
  {
    TicketType: 'MProgramOrder',
    TicketKey: 'test#1111-1111-1112#000-0000-0000',
    ProgramCode: '2',
    Content: '死者蘇生',
    Memo: '死者をよみがえらす',
    ReceiptDateType: 'Onairdate',
    Weekday: 'NoLimit',
  },
  {
    TicketType: 'MProgramOrder',
    TicketKey: 'test#1111-1111-1112#000-0000-0001',
    ProgramCode: '4',
    Content: '強欲な壺',
    Memo: 'ドロー * 2',
    ReceiptDateType: 'BeforeOnairdate',
    CountBeforeOnairdate: '3',
    Weekday: 'NoLimit',
  },
  {
    TicketType: 'MProgramOrder',
    TicketKey: 'test#1111-1111-1112#000-0000-0002',
    ProgramCode: '4',
    Content: '融合',
    Memo: '合体',
    ReceiptDateType: 'BeforeOnairdate',
    CountBeforeOnairdate: '4',
    Weekday: 'NoLimit',
  },
];

/**
 * 発注書の検索処理
 * @param requestModel
 * @returns
 */
export function filterMProgramOrderBySearchDay(requestModel: RequestDataModel) {
  if ('TicketKey' in requestModel.requestData) {
    return MProgramOrderTestData.filter((data) => data.TicketKey === requestModel.requestData.TicketKey);
  }
  return MProgramOrderTestData;
}
